var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.91435L10.0798 3.26273C9.70873 2.6873 9.29198 2.20085 8.83829 1.8074L8.83826 1.80738C7.9454 1.03297 6.94971 0.652344 5.86636 0.652344C4.4035 0.652344 3.0502 1.30624 2.05205 2.52029C1.06191 3.72492 0.5 5.39309 0.5 7.22996C0.5 9.0946 1.11446 10.816 2.48494 12.6706C3.72507 14.3486 5.51619 16.0626 7.64207 18.0943L7.64209 18.0943L7.64446 18.0966C8.36608 18.7863 9.18629 19.5703 10.0382 20.4056L10.0386 20.4059C10.1752 20.5401 10.3396 20.6047 10.5 20.6047C10.6604 20.6047 10.8249 20.54 10.9612 20.4062L10.9614 20.406C11.807 19.5767 12.6218 18.7978 13.3398 18.1116L13.3584 18.0938L13.3584 18.0937C15.484 16.0624 17.2751 14.3486 18.5152 12.6704L18.5152 12.6704C19.8857 10.816 20.5 9.09463 20.5 7.22978C20.5 5.3931 19.9381 3.72494 18.9478 2.52032C17.9496 1.30624 16.5965 0.652344 15.1336 0.652344C14.0503 0.652344 13.0546 1.03295 12.1616 1.80735L10.5 3.91435ZM10.5 3.91435L10.9202 3.26275M10.5 3.91435L10.9202 3.26275M10.9202 3.26275C11.2914 2.68714 11.708 2.20087 12.1615 1.80741L10.9202 3.26275Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartEmpty);
export default __webpack_public_path__ + "static/media/heart-empty.2851e2312ded7fd6c805afdd76d0abb3.svg";
export { ForwardRef as ReactComponent };